/**
 * remark plugin: a single newline inside a paragraph becomes a visible line break.
 *
 * CommonMark folds a lone newline into a space. Users of Planosfera type notes the way they type
 * chat messages, so Enter must mean "next line". The plugin only rewrites newlines inside
 * `text` nodes (paragraphs, list items, headings, quotes, emphasis ...). Code blocks and inline
 * code carry their text in `value` of other node types and are never touched; tables, HTML
 * (skipped), links and everything else keep their CommonMark/GFM meaning.
 */
interface MdNode {
  type: string;
  value?: string;
  children?: MdNode[];
}

function splitText(node: MdNode): MdNode[] {
  const lines = (node.value ?? '').split(/\r?\n/);
  const result: MdNode[] = [];
  lines.forEach((line, index) => {
    if (index > 0) result.push({ type: 'break' });
    if (line !== '') result.push({ type: 'text', value: line });
  });
  return result;
}

function walk(node: MdNode): void {
  if (!node.children) return;
  const next: MdNode[] = [];
  for (const child of node.children) {
    if (child.type === 'text' && child.value?.includes('\n')) {
      next.push(...splitText(child));
    } else {
      walk(child);
      next.push(child);
    }
  }
  node.children = next;
}

export function remarkSoftBreaks() {
  return (tree: MdNode) => {
    walk(tree);
  };
}
